// extracted by mini-css-extract-plugin
module.exports = {"title":"Rooms_title__Ap2a6","content":"Rooms_content__sfjTz","description":"Rooms_description__ZFJT_"};